const state = {
  alert: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/Alert/state.js